//
//
//
//
//
//

export default {
    props: {
        isNeed: {
            type: Boolean,
            default: true,
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/needInput.vue